import MarketingInsightsForm from "../../components/marketingHub/manageMarketingInsights/MarketingInsightsForm";

export const RouteKeys = {
    Login: '/auth/login',
    Home: '/',
    NotFound: '/page-not-found',
    Homeroute: '/home',
    Auth: '/auth',
    AzureLogin: '/auth/aad-redirect',
    AddUser: '/users',
    CreateUser: '/addUser',
    EditUser: '/edituser/:id',
    EmployeeGram: '/employeeGram',
    wallOfFame: '/walloffameDetails',
    wallofFameForm: '/walloffameForm',
    LearningLounge: '/learningLounge',
    ManageInsights: '/manageinsights',
    InsightsForm: '/insightsForm',
    ManageItHub: '/manageithub',
    ItHubForm: '/itHubForm',
    ManageFlashNews: '/manageflashnews',
    FlashNewsForm: '/flashNewsForm',
    PrivacyPolicy: '/privacypolicy',
    TermsAndConditions: '/termsandconditions',
    Reports: '/reports',
    Survey: '/survey',
    ManageSurvey: '/managesurvey',
    SurveyMasterForm: '/surveyMasterForm',
    SurveyQuestionsForm: '/surveyQuestionsForm',
    ManageHubSpoc: '/managehubspoc',
    HubSpocForm: '/hubspocform',
    ManageHomeGallery: '/manageHomeGallery',
    HomeGalleryForm: '/homeGalleryForm',
    ManageHubs: '/manageHubs',
    HubsForm: '/hubsForm',
    ManageThoughtLeadership: '/managethoughtleadership',
    ThoughtLeadershipForm: '/thoughtleadershipform',
    ManageAgilisiumCorner: '/manageagilisiumcorner',
    AgilisiumCornerForm: '/agilisiumcornerform',
};

export const PeopleHubRouteKeys = {
    PeopleHub: '/peopleHub',
    FindYourAssociates: '/findYourAssociates',
    PoliciesAndBenefits: '/policiesAndBenefits',
    ClientSummary: '/clientSummary',
    ManageAnnouncements: '/manageAnnouncements',
    AnnouncementsForm: '/announcementsForm',
    ManageEmployeeSpotlight: '/manageEmployeeSpotlight',
    EmployeeSpotlightForm: '/employeeSpotlightForm',
    ManagePeopleHubGallery: '/managPeopleHubGallery',
    PeopleHubGalleryForm: '/peopleHubGalleryForm',
    AddPolicyForm: '/addPolicyForm',
    ManagePolicy: '/managePolicy',
    ManageClientDetails: '/manageclientdetails',
    ClientDetailsForm: '/clientdetailsForm',
    whatsnew: '/buddyreferrals',
    WhatsNewForm: '/buddyreferralsform',

}
export const TalentTransformationalHubRouteKeys = {
    TalentTransformationalHub: '/talentTransformationalHub',
    MangageLearningLounge: '/managelearninglounge',
    LearningLoungeTable: '/learningloungetable',
    LearningLoungeForm: '/learningloungeform',
}

export const ProcessHubRouteKeys = {
    ProcessHub: '/processHub',
    ManageDocuments: '/manageDocuments',
    DocumentsForm: '/documentsForm',
    BusinessUnits: '/businessUnits',
    OrganizationChart: '/organizationChart',
    ManageDepartments: '/manageDepartments',
    DepartmentsForm: '/departmentsForm',
}

export const MarketingHubRouteKeys = {
    MarketingHub: '/marketingHub',
    Solutions: '/solutions',
    ManageSolutions: '/manageSolutions',
    SolutionsForm: '/solutionsForm',
    ManageMarketingBrochures: '/manageMarketingBrochures',
    MarketingBrochuresForm: '/marketingBrochuresForm',
    ManageMarketingEvents: '/manageMarketingEvents',
    MarketingEventsForm: '/marketingEventsForm',
    ManageRecommendedVideos: '/manageRecommendedVideos',
    RecommendedVideosForm: '/recommendedVideosForm',
    ManageMarketingVideos: '/manageMarketingVideos',
    MarketingVideosForm: '/marketingVideosForm',
    ManageIndustryNews: '/manageindustrynews',
    IndustryNewsForm: '/industrynewsform',
    ManageMarketingInsights: '/manageMarketingInsights',
    MarketingInsightsForm:'/marketingInsightsForm',
    ManagePodcasts: '/managepodcasts',
    PodcastsForm: '/podcastsform',
    ManageMarketingAwards: '/managemarketingawards',
    MarketingAwardsForm: '/marketingawardsform',
    ManageAuthors: '/manageAuthors',
    AuthorsForm: '/authorsForm',
    ManageMarketingHubUsers: '/manageMarketingHubUsers'

}

export const ResourcePulseHubRouteKeys = {
    ResourcePulseHub: '/resourcePulseHub',
    ManageAssociateProfiles: '/manageAssociateProfiles',
    ProfileSearch: '/profilesearch',
    ActiveEmployeesFilterPage: '/activeEmployeesFilterPage',
    CertificationFilterPage: '/certificationFilterPage',
    BenchResourceFilterPage: '/benchResourceFilterPage',
    AssociateDetails: '/associateDetails',
    EmployeeProfile: '/employeeProfile',
    NewHirePage:'/newHirePage',
    BusinessUnitFilterPage: '/businessUnitFilterPage',
    RevenueEngineFilterPage: '/revenueEngineFilterPage',
    PrimaryDepartmentFilterPage: '/primaryDepartmentFilterPage',
    ResignedEmployeesFilterPage: '/resignedEmployeesFilterPage',
    ExitEmployeesFilterPage: '/exitEmployeesFilterPage',
    EmployeesByAccountFilterPage: '/employeesByAccountFilterPage',
    FutureFlexResourceFilterPage: '/futureFlexResourceFilterPage',
    WSRPracticeFilterPage: '/wsrPracticeFilterPage',
    WSRAccountFilterPage: '/wsrAccountFilterPage'
}

export const ContractsHubRouteKeys = {
    ContractsHubCustomer: '/contractsHub/customer',
    ContractsHubVendor: '/contractsHub/vendor',
    ContractsHubHomePage: '/contractsHubHomePage',
}

export const FlipHubRouteKeys = {
    TLF : '/tlfHub',
    
    FlipHub: '/flipHub',
    ManageFlipHubEpisodes : '/manageFlipEpisodes',
    FlipHubEpisodesForm: '/flipHubEpisodesForm',

    TownSquare : '/townSquare',
    ManageTownSquareEpisodes : '/manageTownSquareEpisodes',
    TownSquareEpisodesForm: '/townSquareEpisodesForm',

    BrainGym : '/brainGym',
    ManageBrainGymEpisodes : '/manageBrainGymEpisodes',
    BrainGymEpisodesForm: '/brainGymEpisodesForm',

    KnowHowNow : '/knowHowNow',
    ManageKnowHowNowEpisodes : '/manageKnowHowNowEpisodes',
    KnowHowNowEpisodesForm: '/knowHowNowEpisodesForm',

    ProPoint : '/proPoint',
    ManageProPointEpisodes : '/manageProPointEpisodes',
    ProPointEpisodesForm: '/propointEpisodesForm',

    Kfm : '/kfm',
    ManageKfmEpisodes : '/manageKfmEpisodes',
    KfmEpisodesForm: '/kfmEpisodesForm',
    
}
export const PracticeHubRouteKeys = {
    PracticeHub: '/practiceHub',
    ManagePracticeInsights: '/managePracticeInsights',
    PracticesForm: '/practicesForm',
    PracticeDetails: '/practiceDetails',
    ManagePracticeAnnouncements: '/managePracticeAnnouncements',
    PracticeAnnouncementsForm: '/practiceAnnouncementsForm',
    ManagePracticeMilestones : '/managePracticeMilestones',
    PracticeMilestonesForm : '/practiceMilestonesForm',
    ManagePracticeSkills : '/managePracticeSkills',
    PracticeSkillsForm : '/practiceSkillsForm',
}

export const ImmigrationHubRouteKeys = {
    ImmigrationHub: '/immigrationHub',
    ImmigrationGuidelines: '/immigrationGuidelines'
}

export const AdminHubRouteKeys = {
    AdminHub: '/adminHub',
    ManageSeats : '/manageSeats',
    ManageSeatsForm : '/manageSeatsForm'
}



